import { CreateLinkRequest, Link } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _LinkService {
  public getLinks() {
    return HttpService.get<Link[]>("/links");
  }

  public createLink(body: CreateLinkRequest) {
    return HttpService.post<Link>("/links", {
      body: {
        ...body,
      },
    });
  }

  public deleteLink(id: string) {
    return HttpService.delete(`/links/${id}`);
  }
}

const LinkService = new _LinkService();

export default LinkService;
